import { AccountAttributesEnum } from '../enums';
import { UserService } from '../../core/services/user.service';
import { AppInjector } from '../../app.injector';

export function HasAccess(attributes: AccountAttributesEnum | AccountAttributesEnum[], every?: boolean): Function {
    return function (target: Record<string, unknown>, propertyKey: string): void {
        const resolvingInstances: WeakSet<object> = new WeakSet<object>();
        Object.defineProperty(target, propertyKey, {
            configurable: true,
            get(this: Record<string, unknown>) {
                // Guard against accidental re-entry before the value is materialized.
                if (resolvingInstances.has(this as object)) {
                    return undefined;
                }
                if (Object.prototype.hasOwnProperty.call(this, propertyKey)) {
                    return Object.getOwnPropertyDescriptor(this, propertyKey)?.value;
                }
                resolvingInstances.add(this as object);
                const userServiceInstance: UserService =
                    AppInjector.get().get(UserService);
                const value = userServiceInstance?.hasAccessAsync(attributes, every);
                Object.defineProperty(this, propertyKey, {
                    value,
                    configurable: true,
                });
                resolvingInstances.delete(this as object);
                return value;
            },
        });
    };
}
